/**
 * Local draft persistence for the vendor onboarding wizard.
 *
 * The wizard is long (business + tax + fleet + rates + docs + bank), so every
 * step is saved to localStorage keyed by the partner's mobile number. A vendor
 * can close the tab and come back to exactly where they were. When the backend
 * onboarding endpoint is live this is mirrored server-side via a resume token;
 * until then this is the source of truth for an in-progress application.
 *
 * Nothing here ever throws: storage can be full, disabled, or private-mode.
 */

const PREFIX = "pulpit_partner_draft_"
const key = (mobile) => `${PREFIX}${String(mobile || "anon").replace(/\D/g, "")}`

/** Save (merge) the draft for a mobile. Returns true on success. */
export const saveDraft = (mobile, data) => {
  try {
    const payload = { ...data, _updatedAt: new Date().toISOString() }
    window.localStorage.setItem(key(mobile), JSON.stringify(payload))
    return true
  } catch (e) {
    return false
  }
}

/** Load a saved draft for a mobile, or null. */
export const loadDraft = (mobile) => {
  try {
    const raw = window.localStorage.getItem(key(mobile))
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

/** Clear a draft once the application is submitted. */
export const clearDraft = (mobile) => {
  try {
    window.localStorage.removeItem(key(mobile))
  } catch (e) {
    /* ignore */
  }
}

/** Most recently touched draft on this device, so we can offer "resume". */
export const findLatestDraft = () => {
  try {
    let latest = null
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i)
      if (!k || !k.startsWith(PREFIX)) continue
      const val = JSON.parse(window.localStorage.getItem(k))
      if (val && (!latest || (val._updatedAt || "") > (latest._updatedAt || ""))) {
        latest = { ...val, _mobile: k.slice(PREFIX.length) }
      }
    }
    return latest
  } catch (e) {
    return null
  }
}
